import type { RangeEndClassification } from '../models/overview.types'

interface RangeEndInput {
  queryString?: string | null
  date?: string | Date | null
  now?: Date
  onlyToday?: boolean
  returnMode?: boolean
}

function startOfDay(value: Date): Date {
  const result = new Date(value)
  result.setHours(0, 0, 0, 0)
  return result
}

function endDateOf(input: RangeEndInput): Date | null {
  const raw =
    input.date ??
    (input.queryString ? new URLSearchParams(input.queryString).get('date_end') : null)
  if (!raw) return null
  const result = new Date(raw)
  return Number.isNaN(result.getTime()) ? null : startOfDay(result)
}

export function isRangeEndToday(input: RangeEndInput & { returnMode: true }): RangeEndClassification
export function isRangeEndToday(input: RangeEndInput): boolean
/** Pure, clock-injected port of legacy `startIsToday` and its three return modes. */
export function isRangeEndToday(input: RangeEndInput): boolean | RangeEndClassification {
  const endDate = endDateOf(input)
  if (!endDate) return false

  const today = startOfDay(input.now ?? new Date())
  const yesterday = new Date(today)
  yesterday.setDate(today.getDate() - 1)

  const isToday = endDate.getTime() === today.getTime()
  const isYesterday = endDate.getTime() === yesterday.getTime()

  if (input.returnMode) {
    if (isYesterday) return 'yesterday'
    if (isToday) return 'today'
    return false
  }
  return input.onlyToday ? isToday : isYesterday || isToday
}
